import { computed } from "vue";
import { useMenuStore } from "../Store/menu";
import { useRoute } from "vue-router";

export function useMenu() {
    const route = useRoute();
    const menuStore = useMenuStore();

    menuStore.getArrMenu();

    const activeMenu = computed(() => {
        const basePathCode = route.path.split("/")[1] ?? "";
        const temp = menuStore.arrMenu?.find(item => item.code == basePathCode);
        if (!temp) {
            const children = menuStore.arrMenu?.flatMap(item => item.children)
            return children?.find(item => item.code == basePathCode) ?? null;
        }

        return temp;
    });

    const menus = computed(() => {
        return menuStore.arrMenu?.filter(item => item.menu_group_id == activeMenu.value?.menu_group_id ?? false)
    });


    const arrMenuGroup = computed(() => menuStore.arrMenuGroup ?? []);

    const activeMenuGroup = computed(() => {
        if (!activeMenu.value) return null;

        return arrMenuGroup.value.find(item => item.id == activeMenu.value.menu_group_id);
    })

    return { menus, arrMenuGroup, activeMenu, activeMenuGroup };
}
